<template>
  <div class="mini-calendar__event">
    <div class="mini-calendar__event-main">
      <div class="mini-calendar__event-media">
        <div class="mini-calendar__event-date">
          {{ formatDate(event.date.start.date, 'MMM') }}
          <span class="mini-calendar__date_day">{{ formatDate(event.date.start.date, 'DD') }}</span>
        </div>
        <img v-if="event.image.image_sizes !== undefined " v-lazy="event.image.image_sizes.large" :alt="event.summary"/>
        <img v-else src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" :alt="event.summary"/>

      </div>
      <div class="mini-calendar__event-content">
        <div class="mini-calendar__event-category">
          <ul v-if="event.location" clss="mini-calendar__event-category_text">
            <li>{{event.location}}</li>
          </ul>
          <div class="mini-calendar__event-time">
          {{
            event.date.all_day == "1"
              ? "All Day"
              : (
                  event.date.start.date === event.date.end.date
                    ? (
                        event.date.start.time === event.date.end.time
                          ? event.date.start.time
                          : `${event.date.start.time} - ${event.date.end.time}`
                      )
                    : event.date.start.time
                )
          }}
        </div>

        </div>
        <h2 class="mini-calendar__event-title">
          <a :href="getPath(event.url, event.date_id)" target="_blank">{{event.title}}</a>
        </h2>

        <div class="mini-calendar__event-summary">
          <div class="mini-calendar__event-caption" v-html="event.summary">
          </div>
          <div class="mini-calendar__event-social">
            <div class="mini-calendar__event-line">
              <a :href="getPath(event.url, event.date_id)" class="mini-calendar__button mini-calendar__event-link view-event" target="_blank">View Event</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import MiniCalenderEventSocial from './mini-calendar-event-social.vue'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'MiniCalenderEvent',
  props: {
    event: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters(['date_range'])
  },
  methods: {
    getPath(url, date_id) {
      return date_id ? (url + "?featured_date=" + date_id) : url;
    },
    formatDate(date, format) {
      return moment(date).format(format)
    },
    checkInDate(start_date) {
      if (this.date_range != "" && moment(start_date) <= moment(this.date_range.end)) {
        return true;
      }

      return false;
    }
  }
}
</script>

<style lang="scss">
  .mini-calendar__event {
    display: flex;
    color: $text-color;

    &-date {
      padding-right: rem(10);
      color: $text-color1;
    }

    &-month {
      font-size: rem(20);
      text-transform: uppercase;
      display: block;

      &:after {
        content: "";
        height: 1px;
        width: rem(16);
        background: $background-color2;
        display: block;
      }
    }

    &-day {
      font-size: rem(30);
      font-weight: bold;
      line-height: 1.5;

      &.in-range {
        display: flex;
        width: rem(44);
        height: rem(44);
        align-items: center;
        justify-content: center;
        border: 1px solid $border-color;
        border-radius: 50%;
        margin-top: rem(5);
      }
    }

    &-time {
      padding-left: 10px;
      > span:first-child::after {
        content: "|";
        margin: 0 rem(10);
      }
    }

    &-main {
      width: 100%;
      @include tablet-landscape-up {
        // display: flex;
        // flex-wrap: wrap;
        // gap: rem(10);
      }
    }

    &-title {
      margin: rem(10) 0 rem(10);

      @include desktop-up {
        margin: 0 0 rem(10);
      }

      a {
        color: $text-color1;

        @include desktop-xl-up {
          line-height: 1.5;
          margin-bottom: rem(20);
        }
      }
    }

    &-content {
      @include tablet-landscape-up {
        /*flex: 0 1 auto;
        width: calc(70% - 10px);*/
      }
    }

    &-media {
      display: none;

      img {
        width: auto;
        display: block;
      }

      @include mobile-xl-up {
        display: block;

        img {
          width: auto;
        }
      }

      @include desktop-up {
        width: 30%;
        float: left;
        margin: 0 rem(16) rem(8) 0;

        img {
          width: 100%;
        }
      }
    }

    &-caption {
      margin: 0;
      margin-bottom: 10px;
      line-height: 1.5;
    }

    &-summary {
      @include desktop-xl-up {
        /*padding-left: calc(30% + 10px);
        transform: translateY(-20px);*/
      }
    }

    &-line {
      display: flex;
      justify-content: flex-end;
    }

    &-social {
      .icon-path {
        fill: $text-color1;
      }

      .icon-facebook {
        width: rem(10);
      }
    }

    &-link {
      width: 180px;
      text-align: center;
      margin: rem(4);

      &:hover {
        background-color: $background-color3;
        color: $text-color2;

        .icon-path {
          fill: $text-color2;
        }
      }

    }

    &-category {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      ul {
        list-style: none;
        margin: 0;
        padding: 0;
        display: flex;
        flex-wrap: wrap;

        li {
          list-style: none;
          margin: 0;
          padding: 0 10px 0 0;
          position: relative;

          &:after {
            content: "";
            display: block;
            position: absolute;
            right: 0;
            top: 0;
            bottom: 0;
            width: 1px;
            background-color: #000;
          }
        }
      }
    }
  }
</style>